module.exports = __webpack_public_path__ + "bc3ccd111549681544f4dced01504ba0.svg";